import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  DEFAULT_GRAPHICS_QUALITY_ID,
  findGraphicsQualityById,
  type GraphicsQualityId,
  type GraphicsQualityOption,
} from '../data/graphicsQualityOptions';

export const GRAPHICS_QUALITY_STORAGE_KEY = 'towncar-showroom:graphics-quality:v1';

function readGraphicsQualityId(): GraphicsQualityId {
  if (typeof window === 'undefined') {
    return DEFAULT_GRAPHICS_QUALITY_ID;
  }
  try {
    const stored = window.localStorage.getItem(GRAPHICS_QUALITY_STORAGE_KEY);
    return stored !== null && findGraphicsQualityById(stored) !== undefined
      ? stored as GraphicsQualityId
      : DEFAULT_GRAPHICS_QUALITY_ID;
  } catch {
    return DEFAULT_GRAPHICS_QUALITY_ID;
  }
}

function writeGraphicsQualityId(id: GraphicsQualityId): void {
  try {
    window.localStorage.setItem(GRAPHICS_QUALITY_STORAGE_KEY, id);
  } catch {
    // 저장소가 막혀도 현재 세션의 품질 전환은 유지합니다.
  }
}

export interface GraphicsQualityController {
  quality: GraphicsQualityOption;
  onQualitySelect: (id: string) => void;
}

export function useGraphicsQuality(): GraphicsQualityController {
  const [qualityId, setQualityId] = useState<GraphicsQualityId>(readGraphicsQualityId);
  useEffect(() => writeGraphicsQualityId(qualityId), [qualityId]);
  const onQualitySelect = useCallback((id: string) => {
    if (findGraphicsQualityById(id)) {
      setQualityId(id as GraphicsQualityId);
    }
  }, []);
  const quality = useMemo(() => findGraphicsQualityById(qualityId)!, [qualityId]);
  return { quality, onQualitySelect };
}
